/**
 * MailPoet 3 Overrides
 * -----------------------------------------------------------------------------
 * 
 * MailPoet 3 introduces a number of issues when attempting to theme the form
 * elements it generates. It creates a `<style>` tag with default styles AND
 * links a `mailpoet-public.css` file. The `<style>` tag contains a CSS ID that
 * is specific to each form and is used to scope selectors within it, i.e.
 * `#mailpoet_form_1 .mailpoet_submit`.
 *
 * Normally MailPoet 3 override styles would be included in `style.css`, but a 
 * different approach is being tested as:
 * 
 * 1. All `<style>` tag styles would need to use `!important` declarations to
 *    override those styles and the aforementioned scoping CSS ID is not
 *    predictable.
 * 2. Similarly, the `mailpoet-public.css` file is not included in the `<head>`
 *    of the site, but rather towards the end of the page like a JS file, and we
 *    would need to use "hacks" (i.e. `div.mailpoet_form` vs `.mailpoet_form`)
 *    to increase the specificity of our override selectors as they would be
 *    included in the page before the MailPoet 3 styles.
 *
 * The approach we're implementing is:
 *
 * 1. JS to remove the styles in the `<style>` tag.
 * 2. Generate a CSS file separate from `style.css`. That file will then use the
 *    WordPress template function `wp_enqueue_style()` to make it dependent on
 *    `mailpoet-public.css`.
 * 3. Removing the `_` prefix for SCSS files makes it known that it is not a
 *    partial/module file and can be rendered as a separate file all on its own.
 *
 *    The benefits of this are:
 *
 *    a. The separate file will only be included when `public.js` is
 *       included on a page.
 *    b. The separate file will be included after `public.js` so we
 *       can use the cascade instead of applying specificity "hacks."
 *
 * Notes
 * 1. Container node. Actual `<form>` tag is a descendant.
 * 2. Remove the default styles that MailPoet 3 applies to ALL forms and is
 *    scoped by CSS ID that is specific to each form.
 * 3. Remove inline styles that either the MailPoet 3 plugin applies or that a
 *    user could apply by disabling "Inherit style from theme" for a given form
 *    element.
 */

// Imports
const $ = require( 'jquery' );



// Variables
const $mailpoetForms      = $( '[id^="mailpoet_form_"]' ); // #1
const $removeInlineStyles = [
  'input[type="text"]',
  'input[type="email"]',
  'input[type="password"]',
  'input[type="submit"]',
  'textarea',
  'select',
  'button',
  '.mailpoet-heading',
  '.mailpoet_form_columns',
  '.mailpoet_form_column',
  '.mailpoet_spacer',
  '.mailpoet_divider'
].join( ', ' );



// #2
$mailpoetForms
  .find( '> style:first-of-type' )
    .remove();

// #3
$mailpoetForms 
  .find( $removeInlineStyles )
    .attr( 'style', null );